export default __webpack_public_path__ + "static/media/marker-fuchsia.6e0858fe.png";